import React from "react"
import { Link, IntlContextConsumer } from "gatsby-plugin-intl"
import * as styles from "./header.module.css"

const languageName = {
  zh: "中文",
  ko: "한국어",
  en: "En",
}

const Language = () => (
  <div>
    <IntlContextConsumer>
      {({ languages, language: currentLocale, originalPath }) =>
        languages.map(language => (
          <Link
            key={language}
            to={originalPath}
            language={language}
            className={currentLocale === language ? styles.activeLanguage : ""}
          >
            {languageName[language]}
          </Link>
        ))
      }
    </IntlContextConsumer>
  </div>
)

export default Language
